<template>
	<div>
		<title>我的奖学金-以诺教育</title>
		<div class="orderRight" >
          <h1 class="orderCenter">我的奖学金</h1>
          <div class="zhScholarship">
            <div class="zhLeft">
              <i class="zhJiang">我的奖学金</i><span class="zhPir">{{zhTotal}}</span><span class="datalast" v-show="timeout">({{TimeOutPrice}} 元奖学金将于{{TimeOutTime}}过期)</span>
            </div>
            <div class=zhRight>
              <div class="zhSign"><Icon type="ios-information-outline"></Icon></div><i class="zhJiang1">奖学金规则</i>
            </div>
            <div class="zhInformation" v-show="zhScholarShip">
              <p class="zhProblem"><span class="zhP">Q</span>怎么获得奖学金？</p>
              <p class="zhProblem1"><span class="zhP">A</span>以诺会员成功报名以诺课程并亲历课程10天后，获赠以诺奖学金。按实缴学费获赠不等金额。</p>
              <p class="zhProblem"><span class="zhP">Q</span>奖学金用来做什么？</p>
              <p class="zhProblem1"><span class="zhP">A</span>可以在报名课程时抵扣学费。</p>
              <p class="zhProblem"><span class="zhP">Q</span>什么是有效期？</p>
              <p class="zhProblem1"><span class="zhP">A</span>您获赠的奖学金会有使用期限。超出期限未使用的将被清零。不可再使用。</p>
            </div>
          </div>
          <div class="zhRecord">
            <div class="zhR">全部</div>
            <!--<div class="zhR">消费记录</div>-->
            <!--<div class="zhUnderline"></div>-->
          </div>
          <div class="zhlast">
            <div class="zhRecordList">
              <span class="zhWords">日期</span>
              <span class="zhWords">收入/支出</span>
              <span class="zhWords">详细信息</span>
            </div>
            <div class="zhMoney" v-for="v in zhBurseGetList">
              <span class="zhWords1">{{v.date}}</span>
              <span :class=" `${v.price}` > 0 ? 'zhWords1 zhWordAct' : 'zhWords1' ">{{v.price}}</span>
              <span class="zhWords1">{{v.origin}} <span v-if="v.indate">，有效期：{{v.indate}}</span><span v-if="v.order_id">，订单号：{{v.order_id}}</span></span>
            </div>
            <div class="zhhContent">
              <Page :total="zhPage.total" :page-size="20" @on-change="handlePage"></Page>
            </div>
            <div class="zhTotal">
              共{{zhPage.total}}条记录
            </div>
          </div>
			</div>
			<!--<div class="clear"></div>-->
		</div>
		</div>
</template>

<script>
	export default{
		name:"scholarship",
		data(){
			return {
				zhTotal:0,
				zhBurseGetList:[],
				zhPage:{},
				zhScholarShip:false,
				TimeOutPrice:"",
				TimeOutTime:"",
				timeout:true,
			}
		},
		methods:{
			handlePage(i){
        var that = this;
        $(document).scrollTop(0)
        this.$ajax({
          method:"post",
          url:"/api/BurseGetList",
          params:{page:i}
        })
        .then(function(data){
            that.zhBurseGetList=data.data.data;
           that.zhPage=data.data.meta.pagination;
        })
      },
		},
	mounted(){
		var that=this
		 //初始化 奖学金
    that.$ajax({
      method:"post",
      url:"/api/BurseInfo",
    })
      .then(function(data){
        that.zhTotal = data.data.result.value;
      })
      
     //初始化 获赠记录
		 that.$ajax({
		    method:"post",
		    url:"/api/BurseGetList",
		  })
		  .then(function(data){
		    that.zhBurseGetList = data.data.data;
         that.zhPage=data.data.meta.pagination;
		  })
		$(".zhJiang1").click(function(event){
		    event.stopPropagation();
		    that.zhScholarShip = true;
		  })
		  $(".zhInformation").click(function(event){
        event.stopPropagation();
        that.zhScholarShip = true;
      })
		  $(document).click(function(){
		    that.zhScholarShip = false;
		  })
	  /*---------------------------------奖学金过期处理----------------------------------*/
		 that.$ajax({
		 	method:"post",
		 	url:"/api/TimeOutBurseGet"
		 }).then(function(data){
		 	if(data.data.result==""){
		 		that.timeout=false
		 	}else{
		 		that.timeout=true
		 	}
		 	that.TimeOutPrice=parseInt(data.data.result.price).toFixed(2)
		 	that.TimeOutTime=data.data.result.time
		 }).catch(function(err){
		 	console.log(err)
		 })
	}
	}
</script>

<style>
	.orderList .orderCenter{font-size: 20px;font-weight: 100;margin:26px 30px;}
	.orderList .zhScholarship{position:relative;width:850px;height:85px;background:#e6e8f0;margin:30px 30px 0;box-sizing:border-box;display:flex;justify-content:space-between;align-items: center;}
	.orderList .zhLeft{float:left;overflow:hidden;display:flex;justify-content:space-start;align-items:center;height:30px;}
  .orderList .zhRight{float:right;overflow:hidden;display:flex;justify-content:space-end;align-items: center;}
  .orderList .zhJiang{font-style:normal;margin:0 30px;font-size:14px;color:#4f4f4f;display:block;}
  .orderList .zhPir{color:#01b784;font-size:30px;display:block;}
  .orderList .zhJiang1{font-style:normal;margin:0 30px 0 8px;font-size:14px;color:#01b784;display:block;cursor:pointer;}
  .orderList .zhProblem{font-size:14px;color:#4f4f4f;padding-bottom:10px;padding-left:20px;position:relative;}
  .orderList .zhProblem1{font-size:12px;color:#909090;padding-bottom:16px;overflow:hidden;padding-left:20px;position:relative;}
  .orderList .zhP{font-size:16px;color:#01b784;margin-right:10px;position:absolute;display:block;top:0;left:0;}
  .orderList .zhRecord{width:850px;height:64px;background:#ffffff;margin:0 30px;box-sizing:border-box;border-bottom:2px solid #e6e8f0;position:relative;}
  .orderList .zhUnderline{width:90px;height:2px;background:#01b784;position:absolute;bottom:-2px;left:0;transition:all .5s ease;}
  .zhR{width: 90px;line-height:44px;border-bottom: 2px solid #01b784;text-align: center;color: #01b784;position: absolute;top: 18px;font-weight: 600;}
  .orderList .actions{color:#01b784;}
  .orderList .zhRecordList{width:850px;height:40px;margin:30px 30px 0;background:#f5f5f5;font-size:14px;color:#909090;}
  .orderList .zhWords{display:block;height:100%;display:flex;justify-content:center;align-items: center;float:left;width:208px;}
  .orderList .zhWords:nth-child(2){width:190px;}
  .orderList .zhWords:nth-child(3){padding-left:90px;width:auto;}
  .orderList .ac{display:none;}
  .orderList .zhMoney{width:850px;height:50px;box-sizing:border-box;border-bottom:1px solid #e6e6e6;margin:0 30px;}
  .orderList .zhWords1{display:block;width:208px;height:100%;display:flex;justify-content:center;align-items: center;float:left;}
  .orderList .zhWords1:nth-child(2){width:190px;}
  .orderList .zhWords1:nth-child(3){padding-left:90px;width:446px;justify-content: flex-start;overflow: hidden;}
  .orderList .zhImg{width:100%;height:100%;display:block;}
  .orderList .zhSign{font-size:20px;color:#01b784;}
  .orderList .PaymentOrder:visited{color:#fff;}
  .orderList .PaymentOrder{color:#fff;}
  .orderList .orderDetail{color:#909090;}
  .orderList .orderDetail:visited{color:#909090;}
  .orderList .clear{clear:both;}
  /*.router-link-active{background:#11cc99;color:#fff;}*/
  .orderList .zhInformation{z-index:1;position:absolute;top:65px;right:5px;width:370px;height:280px;background:#ffffff;box-shadow:0 0 15px rgba(0,0,0,.1);box-sizing:border-box;padding:30px;}
  .datalast{font-size: 12px;color: #909090;margin-left: 20px;}
  .orderList .zhhContent{display: flex;justify-content: center;padding-top: 30px;}
  .orderList .ivu-page-total{display: none;}
  .orderList .ivu-page li{border-radius: 50%;}
  .orderList .ivu-page li:hover{border:1px solid #11cc99;}
  .orderList .ivu-page li:hover a{color:#11cc99}
  .orderList .ivu-page .ivu-page-item-active:hover a{color:#ffffff}
  .orderList .ivu-page-item-active{background-color: #11cc99;border-color: #11cc99;}
  .orderList .zhTotal{width:100%;text-align: center;line-height: 50px;}
</style>


// WEBPACK FOOTER //
// scholarship.vue?36157a4d